/* eslint-disable max-len */
import { SvgIconDefaultProps } from './svgIcon.types';

const PinSVGComponent = ({ className, ...props }: SvgIconDefaultProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 13 16"
    fill="none"
    {...props}
  >
    <path
      d="M6.50002 11.0001H2C1.6875 11.0001 1.375 10.8751 1.1875 10.6251C1 10.375 0.9375 10.0625 1 9.7813L1.21875 9.00004C1.53125 7.68754 2.31251 6.62503 3.34376 5.90628L3.75001 1H3.00001C2.90626 1 2.81251 1 2.75001 0.937504C2.59376 0.875004 2.50001 0.687503 2.50001 0.500002C2.50001 0.250001 2.71876 0 3.00001 0H11C11.25 0 11.5 0.250001 11.5 0.500002C11.5 0.687503 11.375 0.875004 11.2188 0.937504C11.1563 1 11.0625 1 11 1H10.25L10.625 5.90628C11.6563 6.62503 12.4376 7.68754 12.7501 9.00004L12.9688 9.7813C13.0313 10.0625 12.9688 10.375 12.7813 10.6251C12.5938 10.8751 12.2813 11.0001 12 11.0001H7.50003V15.5001C7.50003 15.7813 7.25003 16.0001 6.96878 16.0001C6.71878 16.0001 6.46877 15.7813 6.46877 15.5001L6.50002 11.0001ZM4.31251 6.46878L3.90626 6.75003C3.06251 7.31253 2.43751 8.18754 2.18751 9.21879L2 10H6.50002V7.00003C6.50002 6.75003 6.71878 6.50003 7.00003 6.50003C7.25003 6.50003 7.50003 6.75003 7.50003 7.00003V10H12L11.7813 9.21879C11.5313 8.18754 10.9063 7.31253 10.0625 6.75003L9.65629 6.46878L9.21879 1H4.75002L4.31251 6.46878Z"
      fill="currentColor"
    />
  </svg>
);
export default PinSVGComponent;
